import React from 'react';
import {Tooltip} from '@mui/material';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import {Link} from 'react-router-dom';
import {Permission} from '../../../permissions/usePermissions';
import ListItem from '../../core/materialui/ListItem/ListItem';

type SideBarLinkItemProps = {
  permission?: Permission;
  disabled?: boolean;
  selected?: boolean;
  linkTo: any;
  icon: React.ReactElement;
  text: string;
};

const SideBarLinkItem: React.FC<SideBarLinkItemProps> = ({icon, text, linkTo, ...rest}) => {
  return (
    <ListItem component={Link} to={linkTo} {...rest} disableGutters selectedLeftIndicator style={{color: 'black'}}>
      <Tooltip title={text}>
        <ListItemIcon style={{color: 'black'}}>{icon}</ListItemIcon>
      </Tooltip>
      <ListItemText primary={text} style={{color: 'black'}} />
    </ListItem>
  );
};

export default SideBarLinkItem;
